import { Button, Text, WalletButton, Weight } from 'components'

import React from 'react'
import styled from 'styled-components'
import { useSwitchChain } from 'wagmi'

interface CustomProps {
  className?: string
  children?: JSX.Element
  type?: string
  header?: string
  content?: string
  expectedNetwork?: number
}

type Props = CustomProps & React.HTMLProps<HTMLDivElement>

export const ErrorDescription: React.FC<Props> = ({
  className,
  header,
  content,
  type = 'def',
  expectedNetwork,
}) => {
  const { switchChain } = useSwitchChain()
  const networkFriendly = expectedNetwork === 1 ? 'Ethereum' : expectedNetwork
  const wrongNetworkText = expectedNetwork
    ? `Connect your wallet to ${networkFriendly} to enable investing`
    : 'Your wallet is currently connected to an unsupported network. Please switch.'

  return (
    <Wrapper className={className}>
      {type === 'wrong-network' && (
        <BoxDescription>
          <StyledText type={'nav'} weight={Weight.Medium}>
            {wrongNetworkText}
          </StyledText>
          <StyledSwitchButton
            buttonType={'primary'}
            onClick={() => switchChain && switchChain({ chainId: expectedNetwork ?? 1 })}
          >
            Switch {expectedNetwork ? `to ${networkFriendly}` : 'network'}
          </StyledSwitchButton>
        </BoxDescription>
      )}
      {type === 'not-connected' && (
        <>
          <StyledText type={'nav'} weight={Weight.Medium}>
            Your wallet is not connected.
          </StyledText>
          <StyledWalletButton buttonType="primary" />
        </>
      )}
      {type === 'def' && (
        <>
          <StyledText type={'nav'} weight={Weight.Medium}>
            {header}
          </StyledText>
          <StyledText type={'nav'} weight={Weight.Medium}>
            {content}
          </StyledText>
          <StyledWalletButton buttonType="primary" />
        </>
      )}
    </Wrapper>
  )
}

const Wrapper = styled.div`
  height: 357px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  min-height: 100%;
  ${({ theme }) => theme.mediaWidth.Tablet`
    width: calc(100% - 40px);
    margin: 0 auto;
  `}
  ${({ theme }) => theme.mediaWidth.Mobile`
  width: calc(100% - 40px);
  margin: 0 auto;
  `}
`
const StyledText = styled(Text)`
  color: ${({ theme }) => theme.primaryFontColor};
  opacity: 0.4;
  text-align: center;
`

const BoxDescription = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 30px;
  max-width: 550px;
  padding: 10px;
`
const StyledWalletButton = styled(WalletButton)`
  margin-top: 30px;
`

const StyledSwitchButton = styled(Button)`
  padding: 14px 28px;
`
